import CompanyCreate from './CompanyCreate';

export default {
  name: 'companies',
  create: CompanyCreate,
};
